<script>
import { Line } from "vue-chartjs";
import {
  getStyle,
  hexToRgba
} from "@coreui/coreui-pro/dist/js/coreui-utilities";
import { CustomTooltips } from "@coreui/coreui-plugin-chartjs-custom-tooltips";
import { random } from "@/shared/utils";
import moment, { months } from "moment";
import "moment-timezone";

export default {
  components: {
    hexToRgba,
    CustomTooltips
  },
  extends: Line,
  props: ["height"],
  data() {
    return {
      today: null
    };
  },
  methods: {
    getChartData: function(num, time, data) {
      let unit = num.value - 1;
      let format = time.format;
      let show = time.value;

      let userTimezone = "Asia/Bangkok";
      let labels = [];
      let dataChart = [];

      if (
        data.length > 0
      ) {
        let dateLabels;
        for (let i = unit; i >= 0; i--) {
          let emptyDay = moment()
            .tz(userTimezone)
            .subtract(i, show)
            .format(format);
          labels.push(emptyDay);
          let count = 0;
          for (var j = 0; j < data.length; j++) {
            let scans = data[j];
            dateLabels = moment(moment.unix(scans.key))
              .tz(userTimezone)
              .format(format);
            if (dateLabels === emptyDay) {
              count = scans.doc_count;
            }
          }
          dataChart.push(count);
        }
      }
      this.chart(labels, dataChart);
    },
    chart: function(labels, dataChart) {
      const brandInfo = "#0B4C67";
      this.renderChart(
        {
          labels: labels,
          datasets: [
            {
              label: "Submissions From",
              backgroundColor: hexToRgba(brandInfo, 10),
              borderColor: "#0B4C67",
              pointHoverBackgroundColor: "#fff",
              borderWidth: 2,
              data: dataChart
            }
          ]
        },
        {
          responsive: true,
          maintainAspectRatio: false
        }
      );
    }
  }
};
</script>
